import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BkPage, fmtTime, SmallBtn } from "@/components/bookkeeping/BkPage";

const COLOR = { succeeded: "#4CCC06", failed: "#FF6B6B", running: "#F5B700" };

const Body = ({ entity }) => {
  const [jobs, setJobs] = useState(null);
  const load = useCallback(() => api(`/bookkeeping/jobs?entity_id=${entity.id}`).then(setJobs).catch(() => setJobs([])), [entity.id]);
  useEffect(() => { setJobs(null); load(); }, [load]);
  return (
    <>
      <SmallBtn onClick={load} data-testid="bk-jobs-refresh">Refresh</SmallBtn>
      <div className="divide-y divide-[#262626] rounded-xl border border-[#333] bg-[#141414]" data-testid="bk-jobs-list">
        {(jobs || []).map((j) => (
          <div key={j.id} className="flex flex-wrap items-center gap-3 px-4 py-3 text-sm" data-testid={`bk-job-${j.id}`}>
            <span className="w-40 font-bold text-white">{j.job_type.replace(/_/g, " ")}</span>
            <span className="text-xs font-extrabold" style={{ color: COLOR[j.status] }}>{j.status}</span>
            <span className="text-neutral-400">{j.records_processed} records</span>
            <span className="flex-1 text-right text-xs text-neutral-500">{fmtTime(j.started_at)}</span>
            {j.error && <p className="w-full text-xs text-[#FF6B6B]">{j.error}</p>}
          </div>
        ))}
        {jobs && jobs.length === 0 && <p className="p-4 text-sm text-neutral-500" data-testid="bk-jobs-empty">No background jobs have run for this entity yet.</p>}
      </div>
    </>
  );
};

export default function JobLog() {
  return <BkPage title="Job log" testId="bookkeeping-jobs">{({ entity }) => <Body entity={entity} />}</BkPage>;
}
